/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Variant_Ats_NaInputs */

const en_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: N/A`)
};

const de_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: N/A`)
};

const fr_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS : N/A`)
};

const es_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: N/A`)
};

const it_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: N/D`)
};

const nl_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: N.v.t.`)
};

const pl_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: N/D`)
};

const fi_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: ei saatavilla`)
};

const da_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: N/A`)
};

const sv_jobs_variant_ats_na = /** @type {(inputs: Jobs_Variant_Ats_NaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS: ej tillgängligt`)
};

/**
* | output |
* | --- |
* | "ATS: N/A" |
*
* @param {Jobs_Variant_Ats_NaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_variant_ats_na = /** @type {((inputs?: Jobs_Variant_Ats_NaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Variant_Ats_NaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_variant_ats_na(inputs)
	if (locale === "fr") return fr_jobs_variant_ats_na(inputs)
	if (locale === "es") return es_jobs_variant_ats_na(inputs)
	if (locale === "it") return it_jobs_variant_ats_na(inputs)
	if (locale === "nl") return nl_jobs_variant_ats_na(inputs)
	if (locale === "pl") return pl_jobs_variant_ats_na(inputs)
	if (locale === "fi") return fi_jobs_variant_ats_na(inputs)
	if (locale === "da") return da_jobs_variant_ats_na(inputs)
	if (locale === "sv") return sv_jobs_variant_ats_na(inputs)
	return en_jobs_variant_ats_na(inputs)
});